// Formie tokens (CSRF + captchas like Snaptcha) are baked into the form's
// `data-fui-form` config attribute and rendered server-side. On Blitz-cached
// pages this means stale values: Snaptcha rejects the submission with
// "Value not found in database." This hook refreshes those tokens after
// Formie initializes each form on the page.
const refreshFormieTokens = {
    init() {
        document.addEventListener('onFormieInit', (event) => {
            const { formie, form } = event.detail || {};

            if (!formie || !form) {
                return;
            }

            formie.refreshFormTokens(form);
        });
    },
};

export default refreshFormieTokens;
